import {Injectable} from '@angular/core';
import {Http, Response, Headers, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ConfigService} from '../../config/config.service';
import {httpExtensionService} from '../../shared/services/httpextension.service';
import {SessionService} from '../../shared/services/session.service';

@Injectable()
export class FundraiserOrderMaterialsService {

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService) {
    }

    createOrder(data: any): Observable<any> {

        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);

        return this.http.post(this.config.apiURI + 'public/fundraiser/order', data, {
            headers: headers
        });
    }

    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }


}



// WEBPACK FOOTER //
// ./src/app/orders/materials/fundraiser-order-materials.service.ts